import React from 'react';

import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';
import { LogoShort } from '@edu-frontend/modules/src/shared/ui/Logo';
import b from 'b_';
import { Text } from 'platform-components';

import './chat-widget__button.scss';

interface Props {
    onClick: () => void;
    hasUnreadMessage: boolean;
    isHidden: boolean;
}

export const Button = ({ onClick, hasUnreadMessage, isHidden }: Props) => {
    return (
        <div
            className={b('chat-widget', 'button', {
                unread: hasUnreadMessage,
                hidden: isHidden,
            })}
            {...accessibleClick(onClick)}
        >
            <LogoShort className="chat-widget__icon" />
            <Text id="chatWidget.button.text" weight={Text.WEIGHT.M} />
        </div>
    );
};

export default Button;
